const statuses = {
  active: 'ACTIVE',
  testing: 'TESTING',
  inactive: 'INACTIVE',
}

const appearance = {
  allUsers: 'ALL_USERS',
  registered: 'REGISTERED_USERS',
  notRegistered: 'UNREGISTERED_USERS',
}


export default {
  statuses,
  appearance,
}
